if (!customElements.get('arrival-gallery')) {
  customElements.define('arrival-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.arrival-gallery__track');
      this.controls = this.querySelector('.arrival-gallery__controls');
      this.previous = this.querySelector('[name="previous"]');
      this.next = this.querySelector('[name="next"]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;

      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior });
        }
      }, options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.scheduleUpdate());
      this.observer.observe(this.track);
      this.update();
    }

    get behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    move(direction) {
      const slide = this.track.firstElementChild;
      if (!slide) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: this.behavior });
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = maximum <= 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
